import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { PlayButton } from '../PlayButton';

export const RegisterYoutube = {

  // Internal id of the component
  id: 'youtube',

  // Visible label
  label: 'Youtube',

  // Fields the user need to fill out when adding an instance of the component
  fields: [{
    name: 'id',
    label: 'Video ID',
    widget: 'string',
    hint: 'Indsæt den del af url-adressen som kommer efter "https://youtube.com/watch?v=" frem til "&" - det er som regel en tekststreng på 11 tegn',
  }],

  // Pattern to identify a block as being an instance of this component
  // pattern: /^youtube (\S+)$/,
  pattern: /<Youtube id=\{`(.*)`\} \/>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
      id: match[1],
    };
  },

  // Function to create a text block from an instance of this component
  toBlock({ id }) {
    return `<Youtube id={\`${id}\`} />`;
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview({ id }) {
    return (
      <Youtube id={id} isPreviewMode />
    );
  },

};

// eslint-disable-next-line
export const Youtube = ({ id, isPreviewMode }) => {

  const [ shouldDisplayVideo, setShouldDisplayVideo ] = useState(false);

  const handleClick = () => {
    if (Cookies.get('accept-cookies') === 'true') {
      setShouldDisplayVideo(true);
    } else {
      window.location.href = `https://youtube.com/watch?=${id}`;
    }
  };

  return (
    <div className="video">
      <div
        style={{
          padding: 0,
          width: '100%',
          paddingTop: '56.25%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        { (!shouldDisplayVideo && !isPreviewMode) && (
          <>
            <img
              src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`}
              loading="lazy"
              alt="Video"
              style={{
                width: '100%',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <button
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'rgba(0,0,0,.2)',
                margin: 0,
                padding: 0,
                border: 0,
                textAlign: 'center',
              }}
              type="button"
              onClick={() => handleClick()}
            >
              <PlayButton />
            </button>
          </>
        )}
        { (shouldDisplayVideo || isPreviewMode) && (
          <>
            <iframe
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              src={`https://www.youtube.com/embed/${id}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Video"
            />
          </>
        )}
      </div>
    </div>
  );
};
